import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IArticles } from '../../../common/tin-gpt/define-articles';
import ImageNotFound from '../../../images/homepage/Image_not_available.png';
import './styles.verticalNews.scss';
import { Carousel } from 'react-responsive-carousel';

interface Props {
    newsContent: IArticles;
    newsCategory?: string;
    type?: string;
    avgStd?: any;
    isSlider?: boolean;
    isSmall?: boolean;
}

const VerticalNews = (props: Props) => {
    const navigate = useNavigate();
    // const [sources, setSources] = React.useState<string>('')
    // const [sources2, setSources2] = React.useState<string>('')
    // const [textSources, setTextSources] = React.useState<string>('');
    // const [numberTextLimit, setNumberTextLimit] = React.useState<number>(40);
    const [avatarNews, setAvatarNews] = React.useState<any>();
    const [avatarNews2, setAvatarNews2] = React.useState<any>('');



    useEffect(() => {
        if (props.newsContent) {
            if ((props.newsContent.type === 'YOUTUBE' || props.newsContent.type === 'FB_POST' || props.newsContent.type === 'YOUTUBE_SHORT') && (props.newsContent.sourceAvatar && props.newsContent.sourceAvatar !== '' && props.newsContent.sourceAvatar !== null && props.newsContent.sourceAvatar !== undefined && props.newsContent.sourceAvatar !== 'null' && props.newsContent.sourceAvatar !== 'Null')) {
                setAvatarNews(props.newsContent.sourceAvatar)
                setAvatarNews2(`https://www.google.com/s2/favicons?domain=${props.newsContent.link}&sz=256`)
            }
            else {
                setAvatarNews(`https://www.google.com/s2/favicons?domain=${props.newsContent.link}&sz=256`)
                setAvatarNews2('')
            }
        }
    }, []);

    useEffect(() => {
        console.log(props.newsContent);
        // console.log(props.newsContent.textContent);
        
        
    }, [props.newsContent]);

    // Hàm thực hiện giới hạn text
    // const limitTextToThreeWords = (text: string) => {
    //     const words = text.substring(0, numberTextLimit);
    //     if (text.length > numberTextLimit) {
    //         return words + '...';
    //     }
    //     return words;
    // }
    // Hàm thực hiện thay thế ảnh khi ảnh bị lỗi
    const handleImageError = (e: any) => {
        e.target.onerror = null;
        e.target.src = ImageNotFound;
    }

    function capitalizeFirstLetter(string: any) {
        if (!string) return '';

        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const checkLength = (text: string) => {
        if (!text) return '';
        if (text.length > 20) {
            return text.substring(0, 20) + '...';
        }
        return text;
    }

    return (
        <div className={'main-vertical-news ' + (props.type === 'reverse' ? 'reverse' : '')}
            onClick={() => {
                if (!props.isSlider) {
                    console.log(props.newsContent);

                    // const url = new URL(props.newsContent.link);
                    // const text = url.hostname + url.pathname;
                    const text = props.newsContent.link.replace('https://', '');
                    const id = props.newsContent.id

                    console.log(text);

                    if (props.newsContent.type === 'AI'|| text.includes('watch')) {
                        navigate(`/detail-news/id=${id}`,);
                    }
                    else {
                        navigate(`/detail-news/${text}`);
                    }

                    // const tmp = props.newsContent.title.replace(/[/,:?-]/g, '');
                    // const title = tmp.replace(/ /g, '-').toLowerCase();
                    // Gán giá trị id vào localStorage
                    localStorage.setItem('id', props.newsContent.id);
                    localStorage.setItem('link', props.newsContent.link);
                }
            }}
        >
            {props.newsContent.imageContents &&
                <>
                    {
                        props.isSlider ?
                            <>
                                {(props.newsContent.imageContents && props.newsContent.imageContents.length > 0) &&
                                   <>
                                   {
                                       props.newsContent.imageContents.length > 10 ?
                                           <Carousel
                                               infiniteLoop={true}
                                               autoPlay={true}
                                           // autoPlay={true}
                                           // dynamicHeight={true}
                                           >
                                               {props.newsContent.imageContents.slice(0, 10).map((image: any, index: any) => (
                                                   <div>
                                                       {image.length > 1 ?
                                                           <img
                                                               className='image-news'
                                                               src={image[0]}
                                                               alt=''
                                                               onError={handleImageError}
                                                           />
                                                           :
                                                           <img
                                                               className='image-news'
                                                               src={image}
                                                               alt=''
                                                               onError={handleImageError}
                                                           />
                                                       }
                                                   </div>
                                               ))}
                                           </Carousel>
                                           :
                                           <Carousel
                                               infiniteLoop={true}
                                               autoPlay={true}
                                           // autoPlay={true}
                                           // dynamicHeight={true}
                                           >
                                               {props.newsContent.imageContents.map((image: any, index: any) => (
                                                   <div>
                                                       {image.length > 1 ?
                                                           <img
                                                               className='image-news'
                                                               src={image[0]}
                                                               alt=''
                                                               onError={handleImageError}
                                                           />
                                                           :
                                                           <img
                                                               className='image-news'
                                                               src={image}
                                                               alt=''
                                                               onError={handleImageError}
                                                           />
                                                       }
                                                   </div>
                                               ))}
                                           </Carousel>
                                   }
                               </>
                                }
                            </>
                            :
                            <>
                                {props.newsContent.imageContents &&
                                    <img
                                        className='image-news'
                                        src={props.newsContent.imageContents[0] ? props.newsContent.imageContents[0] : ImageNotFound}
                                        alt=""
                                        onError={handleImageError}
                                    />
                                }
                            </>
                    }
                </>
            }
            <div className='main-vertical-news-content'
                onClick={() => {
                    if (props.isSlider) {


                        const url = new URL(props.newsContent.link);
                        const text = url.hostname + url.pathname;
                        const id = props.newsContent.id
                        console.log(text);
                        // const tmp = props.newsContent.title.replace(/[/,:?-]/g, '');
                        // const title = tmp.replace(/ /g, '-').toLowerCase();

                        if (props.newsContent.type === 'AI'|| text.includes('watch')) {
                            navigate(`/detail-news/id=${id}`,);
                        }
                        else {
                            navigate(`/detail-news/${text}`);
                        }

                        // Gán giá trị id vào localStorage
                        localStorage.setItem('id', props.newsContent.id);
                        localStorage.setItem('link', props.newsContent.link);
                    }
                }}
            >
                <div className='title-news' style={{ wordWrap: 'break-word' }} >
                    {props.newsContent.title ? capitalizeFirstLetter(props.newsContent.title) : capitalizeFirstLetter(props.newsContent.textContent)}
                    {/* {props.newsContent.textContent} */}
                </div>
                {props.newsContent.type !== 'AI' ?
                    <div className='source-news'>
                        {avatarNews2 ?
                            <div className='sources-face'>
                                <img
                                    className='sources-main-facebook'
                                    src={avatarNews2 ? avatarNews2 : ImageNotFound}
                                    alt=''
                                />
                                <img
                                    className='sources-main-avatar'
                                    src={avatarNews ? avatarNews : ImageNotFound}
                                    alt=''
                                />
                            </div>
                            :
                            <img
                                className='image-source-news'
                                src={avatarNews ? avatarNews : ImageNotFound}
                                alt=''
                            />
                        }
                        <span className="name-source-news" title={props?.newsContent?.sourceName?.sourceName || props?.newsContent?.sourceName}>
                            {props?.newsContent?.sourceName?.sourceName
                                ?
                                checkLength(props?.newsContent?.sourceName?.sourceName)
                                :
                                checkLength(props?.newsContent?.sourceName)
                            }
                        </span>
                        {props.avgStd &&
                            <span style={{ marginLeft: 5 }}>
                                {/* làm tròn đến 2 chữ số thập phân */}
                                ({props.avgStd && parseFloat(props.avgStd).toFixed(2)})
                            </span>
                        }
                    </div>
                    :
                    <div className='source-news'>
                        {/* <img
                            className='image-source-news'
                            src={LogoInresAi}
                            alt=''
                        />
                        <span className="name-source-news" >
                            Inres.AI
                        </span> */}
                        {props.avgStd &&
                            <span >
                                {/* làm tròn đến 2 chữ số thập phân */}
                                ({props.avgStd && props.avgStd.toFixed(2)})
                            </span>
                        }
                    </div>
                }

            </div>
        </div>
    )
}

export default VerticalNews
